interface SpinnerProps { size?: "sm" | "md" | "lg"; className?: string }
const SIZES = { sm: "h-5 w-5", md: "h-8 w-8", lg: "h-12 w-12" };

export function Spinner({ size = "md", className = "" }: SpinnerProps) {
  return <div className={`${SIZES[size]} animate-spin rounded-full border-4 border-ink-1/10 border-t-walnut ${className}`} />;
}

export function FullPageSpinner() {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-paper">
      <div className="flex flex-col items-center gap-3">
        <Spinner size="md" />
        <p className="annotation">Loading...</p>
      </div>
    </div>
  );
}
